<script>
import { mapGetters, mapState } from 'vuex'
import BreadCrumbs from '@components/breadcrumbs/breadcrumbs-wrapper.vue'
import ProfilePaymentCard from '@components/cards/profile-payment-card.vue'
import Translate from '@components/translate'

export default {
  data () {
    return {
      editCard: false,
      cardInfo: {
        name: '',
        address_line1: '',
        address_line2: '',
        address_city: '',
        address_state: '',
        address_country: '',
        address_zip: ''
      }
    }
  },
  props: {
    hideRouterView: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  components: {
    BreadCrumbs,
    ProfilePaymentCard,
    Translate
  },
  computed: {
    ...mapState(['user', 'home', 'settings', 'challenges', 'challengePage']),
    ...mapGetters(['primaryColor', 'primaryColorRgb', 'loggedIn']),
    card () {
      return this.user && this.user.customer && this.user.customer.sources &&
        this.user.customer.sources.data && this.user.customer.sources.data.length > 0 &&
        this.user.customer.sources.data[0]
    },
    cardPath () {
      switch (this.card.brand.replace(' ', '').toLowerCase()) {
        case 'visa':
          return require('@assets/cards/visa.png')
        case 'american-express':
          return require('@assets/cards/americanexpress.png')
        case 'paypal':
          return require('@assets/cards/paypal.png')
        case 'mastercard':
          return require('@assets/cards/mastercard.png')
        case 'discover':
          return require('@assets/cards/discover.png')
        case 'applepay':
          return require('@assets/cards/applepay.png')
        case 'googlepay':
          return require('@assets/cards/googlepay.png')
        default:
          return require('@assets/cards/visa.png')
      }
    }
  },
  methods: {
    setEditCard (val) {
      this.editCard = val
    }
  }
}
</script>

<template>
  <div class="payment-container" :style="{ '--BGColor': `rgba(${primaryColorRgb}, ${1})`}">
    <BreadCrumbs class="second" v-if="(!hideRouterView && isMobile) || (editCard && card)" @back="editCard && card ? editCard = false : $emit('hide-router-view')" />
    <span class="title"><Translate directive="profile.payment.title" /></span>
    <b-row v-if="card">
    <b-col class="card" :key="card.id">
      <div class="row card-name">
        <div class="col-2">
          <img svg-inline :src="cardPath">
        </div>
        <div class="col">
          <div class="row nick-name">
            <p>{{card.name}}</p>
          </div>
          <div class="row number">
            <p>xxxx {{card.last4}}</p>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
   <ProfilePaymentCard v-if="editCard" @setEditCard="setEditCard"/>
   <b-row v-if="!editCard" class="edit-btn">
   <BaseButton
      type="submit"
      class="button btn-primary edit"
      @click="editCard = true"
    ><Translate directive="profile.payment.formtoggle" />
    </BaseButton>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

img {
  width: 4.5rem;
  height: 4.5rem;
}
.payment-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 3rem 4.5%;
  .row {
    width: 100%;
  }
  .title {
      width: 100%;
      font-family: Nunito Sans;
      font-style: normal;
      font-weight: 800;
      font-size: 23px;
      line-height: 52px;
      letter-spacing: -0.761905px;
    }
    .btn-primary {
      color: white;
      border: 2px solid var(--secondaryColor);
      background-color: var(--secondaryColor);
      height: 2.5rem;
      padding: 0rem 1.4rem;
      border-radius: 2rem;
      font-size: 1rem;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      &.edit {
        border: 2px solid black;
        background-color: black;
        font-size: 0.9rem;
      }
    }
   .breadcrumb-wrapper {
    margin-bottom: 0.1rem;
    align-self: flex-start;
    margin-left: -0.5rem;
    &.second {
      position: absolute;
      left: 0.3rem;
      top: 0.5rem;
    }
    ::v-deep span {
      img {
        margin-right: 0.2rem;
      }
      h5 {
        font-size: 1.2rem;
      }
    }
  }
}
.col {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
  .card {
    position: relative;
    margin-bottom: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-radius: 8px;
    width: 100%;
    .col-2 {
      width: fit-content;
      max-width: fit-content;
    }
    p {
      font-size: 1.5rem;
      font-weight: 900;
      margin-bottom: unset;
    }
    .number {
      p {
        font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;
color: #838383;

      }
    }
    .nick-name {
      p {
        font-style: normal;
        font-weight: bold;
        font-size: 19px;
        line-height: 26px;
        align-items: center;
        color: #000000;
        text-align: start;
      }
    }
  }
</style>
